import { UnitLoadDeviceUsage } from '@/class/model/booking/UnitLoadDeviceUsage'
import StrUtils from '@/utils/StrUtils'
import i18n from '@/lang'

export class UnitLoadDeviceManager {
  /**
   * @param {Object} data
   */
  constructor(data) {
    this._data = data || {}
    this.job = data
    this.removedUnitLoadDeviceUsages = [] // 已经删除的
    this.removeSourceUsages = []//  原始装箱明细数据
  }
  /**
   * 已经删除的原始数据
   */
  clearRemoveSourceUsages() {
    this.removeSourceUsages = []
  }

  /**
   * 获取未装箱的小票
   */
  getUnboxedSlaves() {
    const slaves = []
    if (this.job.masterFlag) {
      for (const slave of this.job.lclSlaves) {
        if (!slave.hasOwnProperty('unitLoadDeviceUsages') || slave.unitLoadDeviceUsages === null || slave.unitLoadDeviceUsages.length === 0) {
          slaves.push(slave)
        } else {
          // 确认是否所有件数都已经装箱，如果有未装箱的，那么放在候选列表里面
          let quantity = slave.quantityActual
          for (const usage of slave.unitLoadDeviceUsages) { quantity -= usage.quantity }

          if (quantity > 0) { slaves.push(slave) }
        }
      }
    }
    return slaves
  }

  /**
   * 批量装箱
   */
  multiLoadUnitLoadDevice(slaves, unitLoadDevice) {
    const usages = []
    for (const slave of slaves) {
      usages.push(this.loadUnitLoadDevice(slave, unitLoadDevice))
    }
    return usages
  }

  /**
   * 装箱
   */
  loadUnitLoadDevice(slave, unitLoadDevice) {
    if (unitLoadDevice.unitLoadDeviceUsage === null) { unitLoadDevice.unitLoadDeviceUsage = [] }

    let usage = this.getExistUsage(slave, unitLoadDevice)

    if (usage === null) {
      usage = new UnitLoadDeviceUsage().fillDefaultValue().getData()

      usage.isDirty = true

      // todo usage.job = slave
      usage.jobUuid = slave.uuid
      if (!slave.unitLoadDeviceUsages) {
        slave.unitLoadDeviceUsages = []
      }
      slave.unitLoadDeviceUsages.push(usage)

      // todo usage.unitLoadDevice = unitLoadDevice
      usage.unitLoadDeviceUuid = unitLoadDevice.uuid
      // 新增的箱子 无uuid 给个标识 用于 refreshUnitLoadDeviceUsageColl 方法中的判断
      if (StrUtils.isEmpty(usage.unitLoadDeviceUuid)) {
        usage.unitLoadDeviceUuid = '-1'
      }
      if (!unitLoadDevice.unitLoadDeviceUsage) {
        unitLoadDevice.unitLoadDeviceUsage = []
      }
      unitLoadDevice.unitLoadDeviceUsage.push(usage)

      usage.quantity = this.getItemLeft(slave)
      usage.weight = this.getWeightLeft(slave)
      usage.cubage = this.getCubageLeft(slave)

      // 工作号上的相关信息
      usage.jobNo = slave.jobNo
      usage.mbl = slave.mbl
      usage.warehouseNo = slave.warehouseNo
      usage.customerId = slave.customerId
      usage.mbl = slave.mbl
      usage.dischargingPortCode = slave.dischargingPortCode
      usage.destinationPortCode = slave.destinationPortCode
      usage.etd = slave.etd
    } else {
      usage.isDirty = true
      usage.quantity = Number(usage.quantity) + this.getItemLeft(slave)
      usage.weight = Number(usage.weight) + this.getWeightLeft(slave)
      usage.cubage = Number(usage.cubage) + this.getCubageLeft(slave)
    }
    return usage
  }
  getItemLeft(input) {
    let quantity = 0
    quantity = input.quantityActual
    for (const usage of input.unitLoadDeviceUsages) {
      quantity = quantity - usage.quantity
    }
    return Number(quantity)
  }
  getWeightLeft(input) {
    let weight = 0
    weight = input.weightActual
    if (isNaN(weight)) weight = 0.0

    for (const usage of input.unitLoadDeviceUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) {
        usedWeight = 0.0
      }
      weight = weight - usedWeight
    }
    return Number(weight)
  }
  getCubageLeft(input) {
    let cubage = 0
    cubage = input.cubageActual
    if (isNaN(cubage)) cubage = 0.0
    for (const usage of input.unitLoadDeviceUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) { usedCubage = 0.0 }
      cubage = cubage - usedCubage
    }
    return Number(cubage)
  }
  /**
   * 批量卸载箱量
   */
  multiUnloadUnitLoadDevice(usages) {
    if (usages != null && usages.length > 0) {
      for (let i = usages.length - 1; i >= 0; i--) {
        this.unloadUnitLoadDevice(usages[i])
      }
    }
  }

  /**
   * 卸载箱量
   */
  unloadUnitLoadDevice(usage) {
    if (!this.checkRemoveSourceUsagesExist(usage)) {
      this.removeSourceUsages.push({ 'usage': usage, 'job': usage.jobUuid })
    }

    // todo  usage.job = null
    // 删除 slave 上的 usage
    const slave = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
    if (slave && slave.unitLoadDeviceUsages) {
      const index = slave.unitLoadDeviceUsages.findIndex(p => p.unitLoadDeviceUuid === usage.unitLoadDeviceUuid)
      slave.unitLoadDeviceUsages.splice(index, 1)
    }
    usage.jobUuid = ''

    usage.unitLoadDeviceUuid = '' // todo usage.unitLoadDevice = null

    if (!StrUtils.isEmpty(usage.uuid)) {
      const actionItem = {}
      actionItem.node = 'unloadUnitLoadDevice'
      actionItem.action = 'DELETE'
      actionItem.entity = usage
      this.removedUnitLoadDeviceUsages.push(actionItem)
    }
  }

  checkRemoveSourceUsagesExist(usage) {
    for (const item of this.removeSourceUsages) {
      const tagUsage = item['usage']
      if (tagUsage === usage) {
        return true
      }
    }
    return false
  }

  /**
   * 获取箱子中已经存在的对应的用量信息
   */
  getExistUsage(slave, unitLoadDevice) {
    let usage = null
    for (const unitLoadDeviceUsage of unitLoadDevice.unitLoadDeviceUsage) {
      if (unitLoadDeviceUsage.jobUuid === slave.uuid) {
        usage = unitLoadDeviceUsage
        break
      }
    }
    if (this.removedUnitLoadDeviceUsages !== null && this.removedUnitLoadDeviceUsages.length > 0) {
      for (let i = this.removedUnitLoadDeviceUsages.length - 1; i >= 0; i--) {
        const action = this.removedUnitLoadDeviceUsages[i]
        var usageEntity = action.entity
        const usegeSourceItem = this.getRemoveSourceUsages(usageEntity)
        if (usegeSourceItem != null) {
          const jobUuid = usegeSourceItem['job']
          if (jobUuid === slave.uuid) {
            usage = usegeSourceItem['usage']

            // todo usage.job = slave
            usage.jobUuid = slave.uuid
            if (!slave.unitLoadDeviceUsages) {
              slave.unitLoadDeviceUsages = []
            }
            slave.unitLoadDeviceUsages.push(usage)

            // todo usage.unitLoadDevice = unitLoadDevice
            usage.unitLoadDeviceUuid = unitLoadDevice.uuid
            if (!unitLoadDevice.unitLoadDeviceUsage) {
              unitLoadDevice.unitLoadDeviceUsage = []
            }
            unitLoadDevice.unitLoadDeviceUsage.push(usage)

            this.removeSourceUsages.indexOf(usegeSourceItem)
            const index = this.removeSourceUsages.indexOf(usegeSourceItem)
            this.removeSourceUsages.splice(index, 1)

            this.removedUnitLoadDeviceUsages.splice(i, 1)
            break
          }
        }
      }
    }
    return usage
  }

  getRemoveSourceUsages(usageEntity) {
    for (const item of this.removeSourceUsages) {
      const tagUsage = item['usage']
      if (tagUsage === usageEntity) {
        return item
      }
    }
    return null
  }

  /**
   * 验证小票箱量分配是否正确
   */
  validateSlavesUsage() {
    let msg = ''
    for (const slave of this.job.lclSlaves) {
      const warning = this.validateSlaveUsage(slave)
      if (warning.length > 0) {
        if (msg.length > 0) { msg += '<br/>' }
        msg += warning
      }
    }
    return msg
  }

  /**
   * 验证小票箱量分配是否正确
   */
  validateSlaveUsage(slave) {
    let sumQuantity = 0
    let sumWeight = 0
    let sumCubage = 0
    const weightActual = Number((Math.round(slave.weightActual * 100) / 100).toFixed(2))
    const cubageActual = Number((Math.round(slave.cubageActual * 1000) / 1000).toFixed(3))
    for (const usage of slave.unitLoadDeviceUsages) {
      sumQuantity += Number(usage.quantity)
      sumWeight += Number(usage.weight)
      sumCubage += Number(usage.cubage)
    }
    sumQuantity = Number(sumQuantity.toFixed())
    sumWeight = Number((Math.round(sumWeight * 100) / 100).toFixed(2))
    sumCubage = Number((Math.round(sumCubage * 1000) / 1000).toFixed(3))
    let msg = ''
    if (sumQuantity > slave.quantityActual) { msg += i18n.t('SeaExport.QuantityOfBoxesAndPieces') + sumQuantity + i18n.t('SeaExport.GreaterActualNumberOfPieces') + slave.quantityActual }
    if (sumWeight > weightActual) { msg += i18n.t('SeaExport.BoxWeight') + sumWeight + i18n.t('SeaExport.GreaterThanActualWeight') + weightActual }
    if (sumCubage > cubageActual) { msg += i18n.t('SeaExport.BoxVolume') + sumCubage + i18n.t('SeaExport.LargerThanActualVolume') + cubageActual }
    if (msg.length > 0) { msg = i18n.t('SeaExport.JobNoColon') + slave.jobNo + '-' + msg }
    return msg
  }
}
